import { Injectable } from '@angular/core';
import { Subject, Observable, concatMap, of } from 'rxjs';
import { AuthService } from './auth.service';
import { ApiService } from './api.service';
import { HelperService } from './helper.service';
import { User } from '../interfaces';
import { RequestInvitationBody, UserRegistrationRequest } from '../../login/models/request.invitation.model';
@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  constructor(
    private readonly authService: AuthService,
    private readonly helperService: HelperService,
    private readonly apiService: ApiService
  ) {}

  /**
   * Return listing of users
   * @param page
   * @param limit
   * @returns {Observable<User[]>}
   */
  getInvitationRequests(page: number = 1, limit: number = 10): Observable<any[]> {
    const subject = new Subject<any[]>();

    this.apiService.httpGet('/api/registration/invitations').subscribe((data: any) => {
      const invitations = new Array<any>();
      data.forEach((inv: any) => {
        inv.avatarUrl = this.helperService.getAvatarNoImage();
        invitations.push(inv);
      });

      subject.next(invitations);
    });

    return subject.asObservable();
  }

  /**
   * Delete user from system
   * @param id
   */
  deleteInvitation(inv: any): Observable<any> {
    const subject = new Subject<any>();

    this.apiService.httpDelete('/api/registration/invitations/' + inv.email).subscribe((data: any) => {
      subject.next(data);
    });

    return subject.asObservable();
  }

  update(
    firstName: string,
    lastName: string,
    jobTitle: string,
    email: string,
    phone: string = '',
    companyName: string,
    password: string,
    rePassword: string,
    sso: boolean = false
  ): Observable<any> {
    const body: UserRegistrationRequest = {
      firstName: firstName,
      lastName: lastName,
      jobTitle: jobTitle,
      email: email,
      username: email,
      phone: phone,
      company: companyName,
      password: password,
      rePassword: rePassword,
      message: null,
      termsAndConditionsAgree: true,
      sso,
    };

    console.log(body);
    return this.apiService.httpPut('/api/registration', body).pipe(
      concatMap((data: any) => {
        this.authService.setAuthUser(data.user);
        return of(data);
      })
    );
  }

  public requestInvitation(
    firstName: string,
    lastName: string,
    company: string,
    email: string,
    message: string
  ): Observable<any> {
    // Build body
    const body: RequestInvitationBody = {
      firstName: firstName,
      lastName: lastName,
      company: company,
      email: email,
      message: message,
    };

    return this.apiService.httpPost('/api/registration/invitations', body);
  }

  public isInvitationCodeValid(code: string): Observable<any> {
    return this.apiService.httpGet('/api/registration/' + code);
  }

  /**
   * Resend Registration email
   * @param user
   * @returns {Observable<any>}
   */
  resendReqistrationEmail(user: User): Observable<any> {
    const subject = new Subject<any>();
    const url = '/api/registration/resendEmail';
    this.apiService.httpPost(url, user).subscribe(
      (data: any) => {
        subject.next(data);
      },
      (err: any) => {
        console.error('Resending email error', err);
        subject.error(err);
      }
    );

    return subject.asObservable();
  }

  checkEmail(email): Observable<any> {
    return this.apiService.httpPost(`/api/registration/checkEmail/${email}`, {});
  }
}
